import { trending } from "@/mocks/gossip";
import { SectionHead, Tag } from "./ui";

const rankColors: Record<string, string> = {
  "1": "bg-primary-500",
  "2": "bg-primary-500",
  "3": "bg-primary-500",
  "4": "bg-accent-500",
  "5": "bg-accent-500",
};

export default function Trending() {
  const max = Math.max(...trending.map((t) => t.hot));
  return (
    <section id="hot" className="bg-background-100/60">
      <div className="mx-auto max-w-[1200px] px-4 py-10 md:px-6 md:py-16">
        <SectionHead
          eyebrow="Trending · 实时热度"
          title="今日热榜：谁被围观的次数最多"
          sub="按全网讨论热度与更新时间综合排序，紧跟明星网红主播与娱乐圈公众人物大V的每一次升温与冷却。"
        />

        <div className="grid gap-x-10 gap-y-2 lg:grid-cols-2">
          {trending.map((t, i) => {
            const isTop3 = i < 3;
            return (
              <a
                key={t.rank}
                href="#star"
                className="group flex items-center gap-4 rounded-xl border border-transparent px-2 py-3 transition hover:border-background-200 hover:bg-background-50"
              >
                <span
                  className={`font-heading grid h-9 w-9 shrink-0 place-items-center rounded-lg text-base font-black text-background-50 ${
                    rankColors[t.rank] ?? "bg-secondary-400 text-background-50"
                  } ${isTop3 ? "" : "opacity-90"}`}
                >
                  {t.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h4 className="truncate text-sm font-semibold text-foreground-900 transition group-hover:text-primary-700 md:text-[15px]">
                      {t.title}
                    </h4>
                    {t.up && <i className="ri-arrow-up-line shrink-0 text-xs text-primary-600" />}
                    {t.stable && <i className="ri-loader-4-line shrink-0 text-xs text-foreground-400" />}
                  </div>
                  <div className="mt-2 flex items-center gap-3">
                    <div className="h-1.5 w-full max-w-[160px] overflow-hidden rounded-full bg-background-200">
                      <div
                        className={`h-full rounded-full ${t.up ? "bg-primary-400" : "bg-accent-500/80"}`}
                        style={{ width: `${(t.hot / max) * 100}%` }}
                      />
                    </div>
                    <span className="shrink-0 text-[11px] text-foreground-500">{t.hot} 热度</span>
                  </div>
                </div>
                <Tag tone={i % 3 === 0 ? "primary" : i % 3 === 1 ? "accent" : "secondary"}>{t.tag}</Tag>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}